// The restaurant's chats in the platform agent's panel (D4). Wording from the Amigo design's copy sheet (Chats, Chats
// none); `status` are the chat statuses of docs/platform-agent/contracts.md §6, `who.kinds` who started a chat.
export default {
  title: 'Conversas',
  new_chat: 'Nova conversa',
  note: {
    team: 'As conversas de todos em {{restaurant}}: as suas, as da sua equipa e as do restaurante.',
    own: 'As suas conversas em {{restaurant}}.',
    // No restaurant selected (D18): the person's own chats started that way.
    no_restaurant:
      'As suas conversas sem restaurante selecionado. Uma conversa passa para as conversas de um restaurante assim que o selecionar.',
  },
  log: 'Todos os pedidos no registo do Amigo',
  days: {
    today: 'Hoje',
    yesterday: 'Ontem',
    earlier: 'Anteriores',
  },
  who: {
    you: 'Você',
    kinds: {
      foodamigos: 'FoodAmigos',
      owner: 'Proprietário',
      staff: 'Equipa',
      partner: 'Parceiro',
    },
  },
  status: {
    done: 'Concluído',
    answered: 'Respondido',
    waiting: 'A aguardar aprovação',
    partial: '{{applied}} de {{total}} aplicados',
    rejected: 'Rejeitado',
    not_yet: 'Ainda não foi possível',
    failed: 'Falhou',
  },
  none: {
    title: 'Ainda não há conversas em {{restaurant}}',
    title_no_restaurant: 'Ainda sem conversas sem restaurante selecionado',
    text: 'As conversas que iniciar aqui ficam aqui, para poder voltar a elas.',
  },
  loading: 'A carregar as conversas…',
  loading_more: 'A carregar mais conversas…',
  load_failed: 'Não foi possível carregar as conversas.',
  retry: 'Tentar novamente',
  // A chat with answers the person hasn't read (QA45), before its last line.
  new_answers_one: 'Nova resposta:',
  new_answers_other: 'Novas respostas:',
};
